import React, { useEffect } from "react"

import { getQueryStringObject } from "utils/utils"
import server from "server/serverController2"

import {
  DenyOrderSection,
  DenyOrderContent,
  DenyOrderNotice,
  RetryButton,
} from "components/presenters/commerce/order/ProcessDenyOrder"

export default function ProcessDenyOrder({ orderNo }) {
  const { product_no, code, orderId } = getQueryStringObject()
  useEffect(() => {
    if (orderNo) {
      let form = {}
      form["toss_err_code"] = code
      form["toss_order_id"] = orderId
      server.postRequestData(`commerce/orders/${orderNo}/invoice/failed`, form, (res) => {})
    }
  }, [code, orderId, orderNo])
  return (
    <DenyOrderSection>
      <DenyOrderContent />
      <DenyOrderNotice
        textList={[
          "주문내역과 결제수단 확인 후 재시도 해보시기 바랍니다.",
          "지속적으로 결제가 이루어지지 않는 경우 고객센터로 문의 주시기 바랍니다.(카카오문의 or 전화문의: 010-9768-2105)",
        ]}
      />
      <RetryButton productNo={product_no} />
    </DenyOrderSection>
  )
}
